var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('el-button',[_vm._v("Hello World")]),(_vm.ipInfo)?_c('p',[_vm._v("当前公网 IP: "+_vm._s(_vm.ipInfo.ip)+"，省: "+_vm._s(_vm.ipInfo.province)+"，市: "+_vm._s(_vm.ipInfo.city))]):_vm._e(),(_vm.isFailed)?_c('p',[_vm._v("获取 IP 信息失败")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }